module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('div', {
    staticClass: "footer",
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "manual_container"
  }, [_c('div', {
    staticClass: "footer_bar clearfix"
  }, [_c('div', {
    staticClass: "footer_social"
  }, [(_vm.props.acf.facebook_url) ? _c('a', {
    attrs: {
      "href": _vm.props.acf.facebook_url,
      "target": "_blank"
    }
  }, [(_vm.props.acf.facebook_icon) ? _c('i', {
    staticClass: "fa",
    class: _vm.props.acf.facebook_icon
  }) : _vm._e()]) : _vm._e()]), _c('div', {
    staticClass: "footer_logo"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [(_vm.props.acf.footer_logo) ? _c('img', {
    attrs: {
      "src": _vm.props.acf.footer_logo,
      "alt": "footer logo"
    }
  }) : _vm._e()])], 1), _c('div', {
    staticClass: "footer_copyright"
  }, [_c('span', [_vm._v("© Copyright " + _vm._s(new Date().getFullYear()) + " - ")]), (_vm.props.acf.footer_copyright) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.footer_copyright)
    }
  }) : _vm._e()])]), _c('div', {
    attrs: {
      "id": "accessibilityWidget"
    }
  }, [_vm._v("Click for Accessibility        ")]), _c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#app'),
      expression: "'#app'"
    }],
    attrs: {
      "id": "back_to_top",
      "href": "#"
    }
  }, [_vm._m(0)])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-angle-up"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-016b90e4","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/footer/footer.pug
// module id = 509
// module chunks = 1